import { ConciergeInvitationProduct, ConciergeSaveTheDateProduct } from '@apps/card/routes/Dashboard/components/ConciergeServiceSection/ConciergeServiceSection.types';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { CurrencyFormatter } from '@shared/utils/currency';
import { times } from 'lodash-es';

// Invitations

const JULY_TRIFOLD: { [n: number]: number } = {
  10: 1092,
  20: 728,
  30: 637,
  40: 618,
  50: 601,
  60: 555,
  70: 509,
  80: 507,
  90: 472,
  100: 471,
  110: 434,
  120: 411,
  130: 399,
  140: 386,
  150: 382,
  160: 380,
  170: 379,
  180: 378,
  190: 377,
  200: 368,
  210: 368,
  220: 368,
  230: 368,
  240: 368,
  250: 368,
  260: 368,
  270: 368,
  280: 368,
  290: 368,
  300: 368,
};

const WILDEST_DREAM: { [n: number]: number } = {
  10: 3728,
  20: 2642,
  30: 2164,
  40: 1775,
  50: 1397,
  60: 1267,
  70: 1155,
  80: 1085,
  90: 1010,
  100: 946,
  110: 930,
  120: 906,
  130: 875,
  140: 864,
  150: 856,
  160: 849,
  170: 842,
  180: 835,
  190: 828,
  200: 811,
  210: 805,
  220: 805,
  230: 805,
  240: 805,
  250: 795,
  260: 795,
  270: 794,
  280: 794,
  290: 794,
  300: 794,
};

const TOGETHER: { [n: number]: number } = {
  10: 2519,
  20: 1619,
  30: 1302,
  40: 1043,
  50: 932,
  60: 865,
  70: 816,
  80: 788,
  90: 759,
  100: 740,
  110: 732,
  120: 732,
  130: 722,
  140: 722,
  150: 722,
  160: 688,
  170: 688,
  180: 688,
  190: 688,
  200: 679,
  210: 679,
  220: 679,
  230: 679,
  240: 679,
  250: 669,
  260: 669,
  270: 669,
  280: 669,
  290: 669,
  300: 669,
};

const MILK_AND_HONEY: { [n: number]: number } = {
  10: 3238,
  20: 2339,
  30: 1937,
  40: 1543,
  50: 1349,
  60: 1221,
  70: 1083,
  80: 1022,
  90: 939,
  100: 874,
  110: 841,
  120: 819,
  130: 792,
  140: 778,
  150: 776,
  160: 774,
  170: 773,
  180: 771,
  190: 770,
  200: 758,
  210: 757,
  220: 756,
  230: 755,
  240: 755,
  250: 749,
  260: 748,
  270: 748,
  280: 747,
  290: 747,
  300: 746,
};

const SAGE: { [n: number]: number } = {
  10: 3941,
  20: 2611,
  30: 2096,
  40: 1746,
  50: 1514,
  60: 1389,
  70: 1271,
  80: 1222,
  90: 1182,
  100: 1128,
  110: 1099,
  120: 1073,
  130: 1053,
  140: 1023,
  150: 1005,
  160: 1000,
  170: 991,
  180: 974,
  190: 971,
  200: 961,
  210: 947,
  220: 944,
  230: 941,
  240: 927,
  250: 925,
  260: 923,
  270: 921,
  280: 908,
  290: 906,
  300: 905,
};

const IVORY: { [n: number]: number } = {
  10: 4403,
  20: 2878,
  30: 2250,
  40: 1817,
  50: 1566,
  60: 1440,
  70: 1310,
  80: 1246,
  90: 1168,
  100: 1101,
  110: 1059,
  120: 1020,
  130: 996,
  140: 971,
  150: 965,
  160: 960,
  170: 955,
  180: 951,
  190: 947,
  200: 938,
  210: 935,
  220: 932,
  230: 929,
  240: 927,
  250: 925,
  260: 923,
  270: 919,
  280: 917,
  290: 915,
  300: 914,
};

const SOFIA: { [n: number]: number } = {
  10: 3628,
  20: 2215,
  30: 1761,
  40: 1394,
  50: 1182,
  60: 1062,
  70: 965,
  80: 916,
  90: 846,
  100: 810,
  110: 771,
  120: 732,
  130: 722,
  140: 716,
  150: 709,
  160: 698,
  170: 694,
  180: 689,
  190: 669,
  200: 666,
  210: 663,
  220: 660,
  230: 657,
  240: 656,
  250: 654,
  260: 649,
  270: 647,
  280: 642,
  290: 641,
  300: 639,
};

const HARMONY_GATEFOLD: { [n: number]: number } = {
  10: 1127,
  20: 859,
  30: 754,
  40: 668,
  50: 633,
  60: 633,
  70: 633,
  80: 633,
  90: 633,
  100: 633,
  110: 625,
  120: 625,
  130: 625,
  140: 625,
  150: 625,
  160: 591,
  170: 591,
  180: 591,
  190: 591,
  200: 591,
  210: 591,
  220: 591,
  230: 591,
  240: 591,
  250: 591,
  260: 591,
  270: 591,
  280: 591,
  290: 591,
  300: 591,
};

const HARMONY: { [n: number]: number } = {
  10: 4370,
  20: 2893,
  30: 2264,
  40: 1831,
  50: 1581,
  60: 1458,
  70: 1332,
  80: 1272,
  90: 1194,
  100: 1127,
  110: 1085,
  120: 1046,
  130: 1022,
  140: 997,
  150: 991,
  160: 986,
  170: 981,
  180: 977,
  190: 973,
  200: 964,
  210: 961,
  220: 958,
  230: 955,
  240: 953,
  250: 951,
  260: 949,
  270: 945,
  280: 943,
  290: 941,
  300: 940,
};

const EMPIRE_NOW: { [n: number]: number } = {
  10: 1512,
  20: 1029,
  30: 864,
  40: 688,
  50: 645,
  60: 587,
  70: 533,
  80: 523,
  90: 484,
  100: 476,
  110: 439,
  120: 414,
  130: 401,
  140: 387,
  150: 382,
  160: 378,
  170: 373,
  180: 371,
  190: 369,
  200: 359,
  210: 358,
  220: 357,
  230: 356,
  240: 355,
  250: 354,
  260: 353,
  270: 352,
  280: 352,
  290: 351,
  300: 350,
};

const BYRON_GATEFOLD: { [n: number]: number } = {
  10: 1127,
  20: 859,
  30: 754,
  40: 668,
  50: 633,
  60: 633,
  70: 633,
  80: 633,
  90: 633,
  100: 633,
  110: 625,
  120: 625,
  130: 625,
  140: 625,
  150: 625,
  160: 591,
  170: 591,
  180: 591,
  190: 591,
  200: 591,
  210: 591,
  220: 591,
  230: 591,
  240: 591,
  250: 591,
  260: 591,
  270: 591,
  280: 591,
  290: 591,
  300: 591,
};

const JARDIN: { [n: number]: number } = {
  10: 1127,
  20: 859,
  30: 754,
  40: 668,
  50: 633,
  60: 633,
  70: 633,
  80: 633,
  90: 633,
  100: 633,
  110: 625,
  120: 625,
  130: 625,
  140: 625,
  150: 625,
  160: 591,
  170: 591,
  180: 591,
  190: 591,
  200: 591,
  210: 591,
  220: 591,
  230: 591,
  240: 591,
  250: 591,
  260: 591,
  270: 591,
  280: 591,
  290: 591,
  300: 591,
};

const CELADON: { [n: number]: number } = {
  10: 1723,
  20: 1397,
  30: 1190,
  40: 944,
  50: 823,
  60: 817,
  70: 786,
  80: 765,
  90: 756,
  100: 737,
  110: 728,
  120: 718,
  130: 708,
  140: 699,
  150: 690,
  160: 690,
  170: 690,
  180: 680,
  190: 681,
  200: 680,
  210: 671,
  220: 670,
  230: 671,
  240: 662,
  250: 662,
  260: 661,
  270: 661,
  280: 652,
  290: 652,
  300: 651,
};

const WILD_MEADOW: { [n: number]: number } = {
  10: 3070,
  20: 1980,
  30: 1601,
  40: 1291,
  50: 1156,
  60: 1069,
  70: 1006,
  80: 969,
  90: 932,
  100: 907,
  110: 899,
  120: 899,
  130: 886,
  140: 886,
  150: 886,
  160: 852,
  170: 852,
  180: 852,
  190: 852,
  200: 840,
  210: 840,
  220: 840,
  230: 840,
  240: 840,
  250: 827,
  260: 827,
  270: 827,
  280: 827,
  290: 827,
  300: 827,
};

const EDEN: { [n: number]: number } = {
  10: 1322,
  20: 1054,
  30: 949,
  40: 863,
  50: 828,
  60: 828,
  70: 828,
  80: 828,
  90: 828,
  100: 828,
  110: 820,
  120: 820,
  130: 820,
  140: 820,
  150: 820,
  160: 786,
  170: 786,
  180: 786,
  190: 786,
  200: 786,
  210: 786,
  220: 786,
  230: 786,
  240: 786,
  250: 786,
  260: 786,
  270: 786,
  280: 786,
  290: 786,
  300: 786,
};

const LUMINOUS: { [n: number]: number } = {
  10: 2351,
  20: 1750,
  30: 1391,
  40: 1179,
  50: 995,
  60: 917,
  70: 858,
  80: 830,
  90: 777,
  100: 750,
  110: 736,
  120: 715,
  130: 710,
  140: 696,
  150: 690,
  160: 683,
  170: 677,
  180: 671,
  190: 664,
  200: 658,
  210: 652,
  220: 645,
  230: 639,
  240: 633,
  250: 626,
  260: 620,
  270: 612,
  280: 606,
  290: 600,
  300: 593,
};

const GRACE_TRIFOLD: { [n: number]: number } = {
  10: 1060,
  20: 934,
  30: 847,
  40: 845,
  50: 739,
  60: 692,
  70: 639,
  80: 611,
  90: 611,
  100: 611,
  110: 591,
  120: 591,
  130: 587,
  140: 579,
  150: 571,
  160: 564,
  170: 558,
  180: 553,
  190: 550,
  200: 545,
  210: 543,
  220: 538,
  230: 535,
  240: 532,
  250: 532,
  260: 529,
  270: 527,
  280: 525,
  290: 523,
  300: 522,
};

const FLUTTER: { [n: number]: number } = {
  10: 4194,
  20: 2941,
  30: 2411,
  40: 2078,
  50: 1856,
  60: 1750,
  70: 1587,
  80: 1496,
  90: 1414,
  100: 1330,
  110: 1276,
  120: 1232,
  130: 1189,
  140: 1163,
  150: 1137,
  160: 1133,
  170: 1129,
  180: 1105,
  190: 1102,
  200: 1100,
  210: 1076,
  220: 1074,
  230: 1072,
  240: 1049,
  250: 1048,
  260: 1046,
  270: 1045,
  280: 1023,
  290: 1021,
  300: 1020,
};

const KOFFEE: { [n: number]: number } = {
  10: 3679,
  20: 2652,
  30: 2223,
  40: 1854,
  50: 1639,
  60: 1515,
  70: 1368,
  80: 1303,
  90: 1230,
  100: 1158,
  110: 1118,
  120: 1087,
  130: 1057,
  140: 1032,
  150: 1019,
  160: 1016,
  170: 1013,
  180: 1001,
  190: 998,
  200: 990,
  210: 979,
  220: 977,
  230: 976,
  240: 966,
  250: 965,
  260: 963,
  270: 962,
  280: 952,
  290: 951,
  300: 950,
};

const GRACE: { [n: number]: number } = {
  10: 5328,
  20: 3384,
  30: 2651,
  40: 2224,
  50: 1939,
  60: 1800,
  70: 1673,
  80: 1613,
  90: 1556,
  100: 1485,
  110: 1445,
  120: 1404,
  130: 1383,
  140: 1343,
  150: 1324,
  160: 1318,
  170: 1312,
  180: 1296,
  190: 1292,
  200: 1282,
  210: 1267,
  220: 1264,
  230: 1261,
  240: 1246,
  250: 1244,
  260: 1242,
  270: 1236,
  280: 1223,
  290: 1221,
  300: 1219,
};

const ROSE_ET_GRIS: { [n: number]: number } = {
  10: 5933,
  20: 3845,
  30: 2995,
  40: 2337,
  50: 1946,
  60: 1704,
  70: 1552,
  80: 1468,
  90: 1345,
  100: 1275,
  110: 1250,
  120: 1220,
  130: 1199,
  140: 1182,
  150: 1172,
  160: 1162,
  170: 1147,
  180: 1136,
  190: 1127,
  200: 1104,
  210: 1094,
  220: 1085,
  230: 1075,
  240: 1065,
  250: 1042,
  260: 1033,
  270: 1021,
  280: 1012,
  290: 1002,
  300: 992,
};

const MEET_YOU_AT_THE_ARCH: { [n: number]: number } = {
  10: 4550,
  20: 3073,
  30: 2444,
  40: 2012,
  50: 1761,
  60: 1638,
  70: 1513,
  80: 1453,
  90: 1374,
  100: 1307,
  110: 1265,
  120: 1227,
  130: 1202,
  140: 1178,
  150: 1171,
  160: 1166,
  170: 1161,
  180: 1157,
  190: 1153,
  200: 1144,
  210: 1141,
  220: 1138,
  230: 1135,
  240: 1133,
  250: 1131,
  260: 1129,
  270: 1125,
  280: 1123,
  290: 1121,
  300: 1120,
};

const DELICATE_LUXE: { [n: number]: number } = {
  10: 4351,
  20: 3073,
  30: 2384,
  40: 1928,
  50: 1659,
  60: 1532,
  70: 1402,
  80: 1339,
  90: 1257,
  100: 1188,
  110: 1143,
  120: 1101,
  130: 1076,
  140: 1050,
  150: 1043,
  160: 1037,
  170: 1032,
  180: 1028,
  190: 1023,
  200: 1014,
  210: 1011,
  220: 1008,
  230: 1005,
  240: 1002,
  250: 1000,
  260: 998,
  270: 993,
  280: 991,
  290: 990,
  300: 988,
};

const LAVENDER_LEAVES: { [n: number]: number } = {
  10: 818,
  20: 604,
  30: 520,
  40: 451,
  50: 423,
  60: 423,
  70: 423,
  80: 423,
  90: 423,
  100: 423,
  110: 417,
  120: 416,
  130: 416,
  140: 416,
  150: 416,
  160: 389,
  170: 389,
  180: 389,
  190: 389,
  200: 389,
  210: 389,
  220: 389,
  230: 389,
  240: 389,
  250: 389,
  260: 389,
  270: 389,
  280: 389,
  290: 389,
  300: 389,
};

const WHITE_GARDEN: { [n: number]: number } = {
  10: 818,
  20: 604,
  30: 520,
  40: 451,
  50: 423,
  60: 423,
  70: 423,
  80: 423,
  90: 423,
  100: 423,
  110: 417,
  120: 416,
  130: 416,
  140: 416,
  150: 416,
  160: 389,
  170: 389,
  180: 389,
  190: 389,
  200: 389,
  210: 389,
  220: 389,
  230: 389,
  240: 389,
  250: 389,
  260: 389,
  270: 389,
  280: 389,
  290: 389,
  300: 389,
};

const GOLD_FOIL_FRAME: { [n: number]: number } = {
  10: 1300,
  20: 1160,
  30: 1038,
  40: 870,
  50: 675,
  60: 630,
  70: 586,
  80: 558,
  90: 530,
  100: 502,
  110: 491,
  120: 480,
  130: 463,
  140: 457,
  150: 452,
  160: 446,
  170: 441,
  180: 435,
  190: 430,
  200: 424,
  210: 418,
  220: 418,
  230: 418,
  240: 418,
  250: 418,
  260: 418,
  270: 418,
  280: 418,
  290: 418,
  300: 418,
};

const GARDEN_WINDOW: { [n: number]: number } = {
  10: 818,
  20: 604,
  30: 520,
  40: 451,
  50: 423,
  60: 423,
  70: 423,
  80: 423,
  90: 423,
  100: 423,
  110: 417,
  120: 416,
  130: 416,
  140: 416,
  150: 416,
  160: 389,
  170: 389,
  180: 389,
  190: 389,
  200: 389,
  210: 389,
  220: 389,
  230: 389,
  240: 389,
  250: 389,
  260: 389,
  270: 389,
  280: 389,
  290: 389,
  300: 389,
};

const LOVE_AND_LEAVES: { [n: number]: number } = {
  10: 818,
  20: 604,
  30: 520,
  40: 451,
  50: 423,
  60: 423,
  70: 423,
  80: 423,
  90: 423,
  100: 423,
  110: 417,
  120: 416,
  130: 416,
  140: 416,
  150: 416,
  160: 389,
  170: 389,
  180: 389,
  190: 389,
  200: 389,
  210: 389,
  220: 389,
  230: 389,
  240: 389,
  250: 389,
  260: 389,
  270: 389,
  280: 389,
  290: 389,
  300: 389,
};

const LUNA_GATEFOLD: { [n: number]: number } = {
  10: 923,
  20: 708,
  30: 624,
  40: 555,
  50: 527,
  60: 527,
  70: 527,
  80: 527,
  90: 527,
  100: 527,
  110: 521,
  120: 520,
  130: 520,
  140: 520,
  150: 520,
  160: 493,
  170: 493,
  180: 493,
  190: 493,
  200: 493,
  210: 493,
  220: 493,
  230: 493,
  240: 493,
  250: 493,
  260: 493,
  270: 493,
  280: 493,
  290: 493,
  300: 493,
};

const EUCALYPTUS: { [n: number]: number } = {
  10: 818,
  20: 604,
  30: 520,
  40: 451,
  50: 423,
  60: 423,
  70: 423,
  80: 423,
  90: 423,
  100: 423,
  110: 417,
  120: 416,
  130: 416,
  140: 416,
  150: 416,
  160: 389,
  170: 389,
  180: 389,
  190: 389,
  200: 389,
  210: 389,
  220: 389,
  230: 389,
  240: 389,
  250: 389,
  260: 389,
  270: 389,
  280: 389,
  290: 389,
  300: 389,
};

const GRAPHITE_BLOOMS: { [n: number]: number } = {
  10: 897,
  20: 682,
  30: 598,
  40: 529,
  50: 501,
  60: 501,
  70: 501,
  80: 501,
  90: 501,
  100: 501,
  110: 495,
  120: 494,
  130: 494,
  140: 494,
  150: 494,
  160: 467,
  170: 467,
  180: 467,
  190: 467,
  200: 467,
  210: 467,
  220: 467,
  230: 467,
  240: 467,
  250: 467,
  260: 467,
  270: 467,
  280: 467,
  290: 467,
  300: 467,
};

const MODERN_SIMPLICITY: { [n: number]: number } = {
  10: 1326,
  20: 1186,
  30: 1064,
  40: 896,
  50: 701,
  60: 656,
  70: 612,
  80: 584,
  90: 556,
  100: 528,
  110: 517,
  120: 506,
  130: 489,
  140: 483,
  150: 478,
  160: 472,
  170: 467,
  180: 461,
  190: 456,
  200: 450,
  210: 444,
  220: 444,
  230: 444,
  240: 444,
  250: 444,
  260: 444,
  270: 444,
  280: 444,
  290: 444,
  300: 444,
};

const IVORY_GARDEN: { [n: number]: number } = {
  10: 923,
  20: 708,
  30: 624,
  40: 555,
  50: 527,
  60: 527,
  70: 527,
  80: 527,
  90: 527,
  100: 527,
  110: 521,
  120: 520,
  130: 520,
  140: 520,
  150: 520,
  160: 493,
  170: 493,
  180: 493,
  190: 493,
  200: 493,
  210: 493,
  220: 493,
  230: 493,
  240: 493,
  250: 493,
  260: 493,
  270: 493,
  280: 493,
  290: 493,
  300: 493,
};

const GARDEN_ESTATE: { [n: number]: number } = {
  10: 1326,
  20: 1186,
  30: 1064,
  40: 896,
  50: 701,
  60: 656,
  70: 612,
  80: 584,
  90: 556,
  100: 528,
  110: 517,
  120: 506,
  130: 489,
  140: 483,
  150: 478,
  160: 472,
  170: 467,
  180: 461,
  190: 456,
  200: 450,
  210: 444,
  220: 444,
  230: 444,
  240: 444,
  250: 444,
  260: 444,
  270: 444,
  280: 444,
  290: 444,
  300: 444,
};

const BOTANICAL_GEO: { [n: number]: number } = {
  10: 923,
  20: 708,
  30: 624,
  40: 555,
  50: 527,
  60: 527,
  70: 527,
  80: 527,
  90: 527,
  100: 527,
  110: 521,
  120: 520,
  130: 520,
  140: 520,
  150: 520,
  160: 493,
  170: 493,
  180: 493,
  190: 493,
  200: 493,
  210: 493,
  220: 493,
  230: 493,
  240: 493,
  250: 493,
  260: 493,
  270: 493,
  280: 493,
  290: 493,
  300: 493,
};

// Save the Dates

const LUNA: { [n: number]: number } = {
  10: 1433,
  20: 848,
  30: 616,
  40: 490,
  50: 403,
  60: 377,
  70: 356,
  80: 339,
  90: 319,
  100: 303,
  110: 296,
  120: 281,
  130: 278,
  140: 269,
  150: 266,
  160: 264,
  170: 262,
  180: 260,
  190: 259,
  200: 257,
  210: 256,
  220: 255,
  230: 254,
  240: 252,
  250: 252,
  260: 251,
  270: 249,
  280: 248,
  290: 247,
  300: 247,
};

const MINIMALISME: { [n: number]: number } = {
  10: 1791,
  20: 1060,
  30: 771,
  40: 613,
  50: 504,
  60: 471,
  70: 444,
  80: 423,
  90: 399,
  100: 379,
  110: 369,
  120: 351,
  130: 347,
  140: 337,
  150: 333,
  160: 330,
  170: 328,
  180: 325,
  190: 323,
  200: 321,
  210: 320,
  220: 318,
  230: 317,
  240: 316,
  250: 315,
  260: 314,
  270: 311,
  280: 310,
  290: 309,
  300: 309,
};

const SUMMER_MONTAGE: { [n: number]: number } = {
  '10': 1469,
  '20': 869,
  '30': 632,
  '40': 502,
  '50': 413,
  '60': 387,
  '70': 364,
  '80': 347,
  '90': 327,
  '100': 311,
  '110': 303,
  '120': 288,
  '130': 285,
  '140': 276,
  '150': 273,
  '160': 271,
  '170': 269,
  '180': 267,
  '190': 265,
  '200': 263,
  '210': 263,
  '220': 261,
  '230': 260,
  '240': 259,
  '250': 258,
  '260': 257,
  '270': 255,
  '280': 254,
  '290': 253,
  '300': 253,
};

const SUMMER_NIGHTS: { [n: number]: number } = {
  '10': 1469,
  '20': 869,
  '30': 632,
  '40': 502,
  '50': 413,
  '60': 387,
  '70': 364,
  '80': 347,
  '90': 327,
  '100': 311,
  '110': 303,
  '120': 288,
  '130': 285,
  '140': 276,
  '150': 273,
  '160': 271,
  '170': 269,
  '180': 267,
  '190': 265,
  '200': 263,
  '210': 263,
  '220': 261,
  '230': 260,
  '240': 259,
  '250': 258,
  '260': 257,
  '270': 255,
  '280': 254,
  '290': 253,
  '300': 253,
};

const LINEAR: { [n: number]: number } = {
  '10': 1053,
  '20': 852,
  '30': 708,
  '40': 564,
  '50': 483,
  '60': 425,
  '70': 387,
  '80': 390,
  '90': 384,
  '100': 368,
  '110': 368,
  '120': 368,
  '130': 368,
  '140': 355,
  '150': 355,
  '160': 355,
  '170': 355,
  '180': 355,
  '190': 355,
  '200': 348,
  '210': 348,
  '220': 348,
  '230': 348,
  '240': 348,
  '250': 348,
  '260': 348,
  '270': 348,
  '280': 348,
  '290': 348,
  '300': 348,
};

const POLAROID: { [n: number]: number } = {
  '10': 835,
  '20': 537,
  '30': 403,
  '40': 326,
  '50': 269,
  '60': 262,
  '70': 254,
  '80': 247,
  '90': 236,
  '100': 226,
  '110': 223,
  '120': 213,
  '130': 213,
  '140': 208,
  '150': 208,
  '160': 208,
  '170': 208,
  '180': 208,
  '190': 208,
  '200': 208,
  '210': 208,
  '220': 208,
  '230': 208,
  '240': 208,
  '250': 208,
  '260': 208,
  '270': 207,
  '280': 207,
  '290': 207,
  '300': 207,
};

const DELILAH: { [n: number]: number } = {
  '10': 1226,
  '20': 842,
  '30': 651,
  '40': 497,
  '50': 408,
  '60': 347,
  '70': 305,
  '80': 300,
  '90': 288,
  '100': 271,
  '110': 267,
  '120': 264,
  '130': 261,
  '140': 247,
  '150': 245,
  '160': 243,
  '170': 242,
  '180': 240,
  '190': 239,
  '200': 232,
  '210': 231,
  '220': 230,
  '230': 229,
  '240': 229,
  '250': 228,
  '260': 227,
  '270': 227,
  '280': 226,
  '290': 226,
  '300': 225,
};

const FLOWERET: { [n: number]: number } = {
  '10': 1226,
  '20': 842,
  '30': 651,
  '40': 497,
  '50': 408,
  '60': 347,
  '70': 305,
  '80': 300,
  '90': 288,
  '100': 271,
  '110': 267,
  '120': 264,
  '130': 261,
  '140': 247,
  '150': 245,
  '160': 243,
  '170': 242,
  '180': 240,
  '190': 239,
  '200': 232,
  '210': 231,
  '220': 230,
  '230': 229,
  '240': 229,
  '250': 228,
  '260': 227,
  '270': 227,
  '280': 226,
  '290': 226,
  '300': 225,
};

const MINIMALIST_BLACK_WHITE: { [n: number]: number } = {
  '10': 962,
  '20': 851,
  '30': 670,
  '40': 579,
  '50': 481,
  '60': 418,
  '70': 383,
  '80': 363,
  '90': 342,
  '100': 314,
  '110': 279,
  '120': 272,
  '130': 265,
  '140': 258,
  '150': 251,
  '160': 244,
  '170': 237,
  '180': 230,
  '190': 223,
  '200': 216,
  '210': 209,
  '220': 209,
  '230': 209,
  '240': 209,
  '250': 209,
  '260': 209,
  '270': 209,
  '280': 209,
  '290': 209,
  '300': 209,
};

const BYRON: { [n: number]: number } = {
  '10': 986,
  '20': 872,
  '30': 687,
  '40': 593,
  '50': 493,
  '60': 429,
  '70': 393,
  '80': 372,
  '90': 350,
  '100': 322,
  '110': 286,
  '120': 279,
  '130': 272,
  '140': 264,
  '150': 258,
  '160': 250,
  '170': 243,
  '180': 236,
  '190': 229,
  '200': 222,
  '210': 214,
  '220': 214,
  '230': 214,
  '240': 214,
  '250': 214,
  '260': 214,
  '270': 214,
  '280': 214,
  '290': 214,
  '300': 214,
};

const CLAIR_DE_LUNE: { [n: number]: number } = {
  '10': 1444,
  '20': 944,
  '30': 705,
  '40': 542,
  '50': 451,
  '60': 411,
  '70': 378,
  '80': 349,
  '90': 341,
  '100': 327,
  '110': 313,
  '120': 299,
  '130': 299,
  '140': 299,
  '150': 299,
  '160': 299,
  '170': 288,
  '180': 286,
  '190': 286,
  '200': 286,
  '210': 286,
  '220': 286,
  '230': 286,
  '240': 286,
  '250': 286,
  '260': 286,
  '270': 286,
  '280': 286,
  '290': 286,
  '300': 286,
};

export const formatter = new CurrencyFormatter({ locale: 'en', defaultCurrency: 'USD' });

export type QuantityPriceConfig = {
  quantity: number;
  totalPriceInMinorUnits: number;
  individualPriceString: string;
  totalPriceString: string;
};

const _generatePriceConfig = ({ getIndividualPriceByQuantityInMinorUnits }: { getIndividualPriceByQuantityInMinorUnits: (quantity: number) => number }) => {
  const configByQuantity: Record<number, QuantityPriceConfig> = {};
  times(300 / 10, num => {
    const quantity = (num + 1) * 10;
    const individPriceInMinorUnits = getIndividualPriceByQuantityInMinorUnits(quantity);
    const totalPriceInMinorUnits = quantity * individPriceInMinorUnits;

    const config: QuantityPriceConfig = {
      quantity,
      totalPriceInMinorUnits,
      individualPriceString: formatter.formatCurrency(individPriceInMinorUnits / 100, { form: 'auto' }),
      totalPriceString: formatter.formatCurrency(totalPriceInMinorUnits / 100, { form: 'auto' }),
    };

    configByQuantity[quantity] = config;
  });

  return configByQuantity;
};

export type ConciergeServiceCategory = StationeryTemplateCategoryEnum.invitation | StationeryTemplateCategoryEnum.saveTheDate;

export const isConciergeServiceCategory = (category: StationeryTemplateCategoryEnum): category is ConciergeServiceCategory => {
  return [StationeryTemplateCategoryEnum.invitation, StationeryTemplateCategoryEnum.saveTheDate].includes(category);
};

type PriceConfigItem = Record<
  number,
  {
    quantity: number;
    totalPriceInMinorUnits: number;
    individualPriceString: string;
    totalPriceString: string;
  }
>;

type PriceConfig = {
  [StationeryTemplateCategoryEnum.invitation]: {
    quantity: {
      [key in ConciergeInvitationProduct]: PriceConfigItem;
    };
    upgrades?: {
      [k: string]: PriceConfigItem;
    };
  };
  [StationeryTemplateCategoryEnum.saveTheDate]: {
    quantity: {
      [key in ConciergeSaveTheDateProduct]: PriceConfigItem;
    };
    upgrades?: {
      [k: string]: PriceConfigItem;
    };
  };
};

export const PRICE_CONFIG: PriceConfig = {
  [StationeryTemplateCategoryEnum.invitation]: {
    quantity: {
      [ConciergeInvitationProduct.JulyTrifold]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return JULY_TRIFOLD[quantity];
        },
      }),
      [ConciergeInvitationProduct.WildestDream]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WILDEST_DREAM[quantity];
        },
      }),
      [ConciergeInvitationProduct.Together]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return TOGETHER[quantity];
        },
      }),
      [ConciergeInvitationProduct.Sofia]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SOFIA[quantity];
        },
      }),
      [ConciergeInvitationProduct.Sage]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SAGE[quantity];
        },
      }),
      [ConciergeInvitationProduct.MilkAndHoney]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MILK_AND_HONEY[quantity];
        },
      }),
      [ConciergeInvitationProduct.Jardin]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return JARDIN[quantity];
        },
      }),
      [ConciergeInvitationProduct.Ivory]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return IVORY[quantity];
        },
      }),
      [ConciergeInvitationProduct.Harmony]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return HARMONY[quantity];
        },
      }),
      [ConciergeInvitationProduct.HarmonyGatefold]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return HARMONY_GATEFOLD[quantity];
        },
      }),
      [ConciergeInvitationProduct.EmpireNow]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EMPIRE_NOW[quantity];
        },
      }),
      [ConciergeInvitationProduct.ByronGatefold]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BYRON_GATEFOLD[quantity];
        },
      }),
      [ConciergeInvitationProduct.Celadon]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return CELADON[quantity];
        },
      }),
      [ConciergeInvitationProduct.WildMeadow]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WILD_MEADOW[quantity];
        },
      }),
      [ConciergeInvitationProduct.Eden]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EDEN[quantity];
        },
      }),
      [ConciergeInvitationProduct.Luminous]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUMINOUS[quantity];
        },
      }),
      [ConciergeInvitationProduct.GraceTrifold]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRACE_TRIFOLD[quantity];
        },
      }),
      [ConciergeInvitationProduct.Flutter]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return FLUTTER[quantity];
        },
      }),
      [ConciergeInvitationProduct.Koffee]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return KOFFEE[quantity];
        },
      }),
      [ConciergeInvitationProduct.Grace]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRACE[quantity];
        },
      }),
      [ConciergeInvitationProduct.RoseEtGris]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return ROSE_ET_GRIS[quantity];
        },
      }),
      [ConciergeInvitationProduct.MeetYouAtTheArch]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MEET_YOU_AT_THE_ARCH[quantity];
        },
      }),
      [ConciergeInvitationProduct.DelicateLuxe]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return DELICATE_LUXE[quantity];
        },
      }),
      [ConciergeInvitationProduct.LavenderLeaves]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LAVENDER_LEAVES[quantity];
        },
      }),
      [ConciergeInvitationProduct.WhiteGarden]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return WHITE_GARDEN[quantity];
        },
      }),
      [ConciergeInvitationProduct.GoldFoilFrame]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GOLD_FOIL_FRAME[quantity];
        },
      }),
      [ConciergeInvitationProduct.GardenWindow]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GARDEN_WINDOW[quantity];
        },
      }),
      [ConciergeInvitationProduct.LoveAndLeaves]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LOVE_AND_LEAVES[quantity];
        },
      }),
      [ConciergeInvitationProduct.LunaGatefold]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUNA_GATEFOLD[quantity];
        },
      }),
      [ConciergeInvitationProduct.Eucalyptus]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return EUCALYPTUS[quantity];
        },
      }),
      [ConciergeInvitationProduct.GraphiteBlooms]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GRAPHITE_BLOOMS[quantity];
        },
      }),
      [ConciergeInvitationProduct.ModernSimplicity]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MODERN_SIMPLICITY[quantity];
        },
      }),
      [ConciergeInvitationProduct.IvoryGarden]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return IVORY_GARDEN[quantity];
        },
      }),
      [ConciergeInvitationProduct.GardenEstate]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return GARDEN_ESTATE[quantity];
        },
      }),
      [ConciergeInvitationProduct.BotanicalGeo]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BOTANICAL_GEO[quantity];
        },
      }),
    },
  },
  [StationeryTemplateCategoryEnum.saveTheDate]: {
    upgrades: {
      magnetic: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: () => {
          return 99;
        },
      }),
    },
    quantity: {
      [ConciergeSaveTheDateProduct.Luna]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LUNA[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Minimalisme]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MINIMALISME[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.SummerMontage]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SUMMER_MONTAGE[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.SummerNights]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return SUMMER_NIGHTS[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Linear]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return LINEAR[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Polaroid]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return POLAROID[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Delilah]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return DELILAH[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Floweret]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return FLOWERET[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.MinimalistBlackWhite]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return MINIMALIST_BLACK_WHITE[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.Byron]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return BYRON[quantity];
        },
      }),
      [ConciergeSaveTheDateProduct.ClairDeLune]: _generatePriceConfig({
        getIndividualPriceByQuantityInMinorUnits: quantity => {
          return CLAIR_DE_LUNE[quantity];
        },
      }),
    },
  },
};
